import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Typography, Tabs, TabList, Tab } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { PageHelpButton } from '../../components/knowledge-base/PageHelpButton';

export const HawkeyeAppUnified: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract the current tab from the URL path
  const getActiveTab = () => {
    const path = location.pathname.replace('/hawkeye', '').replace('/', '');
    return path || 'dashboard';
  };

  const handleTabChange = (_event: React.SyntheticEvent | null, newValue: string | number | null) => {
    if (newValue) {
      if (newValue === 'dashboard') {
        navigate('/hawkeye');
      } else {
        navigate(`/hawkeye/${newValue}`);
      }
    }
  };

  return (
    <Box sx={{ p: 3, width: '95%', mx: 'auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <Typography level="h2">
          Hawkeye Analytics
        </Typography>
        <PageHelpButton />
      </Box>

      <Tabs value={getActiveTab()} onChange={handleTabChange} sx={{ mb: 3, width: '100%' }}>
        <TabList sx={{ width: '100%' }}>
          <Tab value="dashboard">Dashboard</Tab>
          <Tab value="analyze">Submit Analysis</Tab>
          <Tab value="history">Analysis History</Tab>
        </TabList>
      </Tabs>

      <Outlet />
    </Box>
  );
};